<button 
    mat-icon-button 
    class="btn" 
    (click)="createDocument()">
    <mat-icon>create</mat-icon>
</button>
